// extracted by mini-css-extract-plugin
export default {"dev":"Footer_dev__MJtpH","copyrgt":"Footer_copyrgt__Qnj7A","number":"Footer_number__WCdEf","icon":"Footer_icon__nQ53P","row":"Footer_row__8-9yB"};